import { supabase } from "./supabaseClient";
import type { Event } from "@/types/database";

export async function fetchActiveEvent(): Promise<Event | null> {
  const { data, error } = await supabase
    .from("events")
    .select("*")
    .eq("active", true)
    .maybeSingle();
  if (error) return null;
  return (data ?? null) as Event | null;
}

export async function fetchEvents(opts: { includeArchived?: boolean } = {}): Promise<Event[]> {
  let q = supabase.from("events").select("*").order("starts_at", { ascending: false });
  if (!opts.includeArchived) q = q.eq("archived", false);
  const { data } = await q;
  return (data ?? []) as Event[];
}

export function formatEventLabel(e: Event): string {
  const loc = e.city ? ` · ${e.city}` : "";
  const date = e.starts_at ? ` · ${new Date(e.starts_at).toLocaleDateString()}` : "";
  return `${e.name}${loc}${date}`;
}
